// import { TimelineMax, Power4, Power3 } from 'gsap';

export default {
  init() {
    // JavaScript to be fired on all pages
    const body = document.querySelector('body');

    const isChrome = !!window.chrome;

    if (isChrome) {
      body.classList.add('chrome');
    }

    const isWindows = navigator.platform.indexOf('Win') > -1;

    if (isWindows) {
      body.classList.add('windows');
    }

    // Cookie consent
    const cookieButton = document.querySelector('.cookie_consent button');
    if (cookieButton !== null) {
      document.querySelector('.cookie_consent button').addEventListener('click', function (e) {
        e.preventDefault()
        const expiryDate = new Date()
        expiryDate.setDate(expiryDate.getDate() + 365)
        document.cookie = 'onea-cookie-consent=1; expires=' + expiryDate.toGMTString() + '; path=/'
        document.querySelector('.cookie_consent').classList.add('hidden')
      })

      if (document.cookie.indexOf('onea-cookie-consent=') !== -1) {
        document.querySelector('.cookie_consent').classList.add('hidden')
      }
    }



  },
  isMobile() {
    return {
      Android: () => {
          return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: () => {
          return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: () => {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: () => {
          return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: () => {
          return navigator.userAgent.match(/IEMobile/i);
      },
      any: () => {
          return (this.isMobile().Android() || this.isMobile().BlackBerry() || this.isMobile().iOS() || this.isMobile().Opera() || this.isMobile().Windows());
      },
      none: () => {
          return (!this.isMobile.any());
      },
    }
  },
  loaderSetup() {
    /*
    const $listEl = $('#preloader ul')
    const loaderHeight = $(window).width() < 1920 ? $(window).width()*.5989 : $(window).width()*.4775;

    this.loaderTimeline = new TimelineMax(
    )
    .set('#preloader', {
      pointerEvents: 'all',
      opacity: 1,
    })
    .set($listEl,{
        opacity:1,
    })
    .fromTo($listEl, 5,{
      y: $listEl.height(),
    },{
      y: ($listEl.height()*-1) + ((loaderHeight - 67) / 2) + 30,
      ease: Power4.easeInOut,
    }, 'intro')
    .to($('#preloader li:not(:last-child)'),1,{
      autoAlpha:0,
      ease:Power3.easeInOut,
      delay:3.75,
    }, 'intro')
    .fromTo($('#preloader li:last-child span'),1,{
      width:0,
      opacity:0,
      marginLeft: '-2px',
      ease:Power4.easeInOut,
      delay: 4.5,
    }, {
      width: '1.3ch',
      marginLeft: '-2px',
      opacity: 1,
    })
    .to($('#preloader'),1,{
      opacity: 0,
      pointerEvents: 'none',
    })
    */
    // to($($listEl),1,{
    //     autoAlpha:0,
    //     ease:Power3.easeInOut,
    //     delay:3.5
    // },'intro').
    $('html').addClass('loaded');
  },
  finalize() {
    // Remove preloder for now
    // if (this.compareLocalStorageTimestramp() && !this.isMobile().any()) {
    //   window.addEventListener('load', () => {
    //     setTimeout(() => {
    //       this.loaderSetup()
    //     }, 200)
    //     this.setLocalStorage()
    //   });
    // } else {
    //   window.addEventListener('load', () => {
    //     $('html').addClass('loaded');
    //     $('#preloader').css('opacity', 0);
    //   });
    // }

    window.addEventListener('load', () => {
      $('html').addClass('loaded');
      $('#preloader').css('opacity', 0);
    });

    if (location.hash) {
      setTimeout(() => {
        const el = document.querySelector(location.hash).getBoundingClientRect()
        if (el.top - document.body.scrollTop > 200) {
          window.scrollTo({
            top: el.top,
            behavior: 'smooth',
          })
        }
      }, 500);
    }

    const links = document.querySelectorAll('header.banner a')
    const checkbox = document.querySelector('header.banner input[type=checkbox]')

    links.forEach((l) => {
      l.addEventListener('click', () => {
        checkbox.checked = false
      })
    })

  },
  setLocalStorage() {
    const storageObj = {
      loaded: true,
      timestamp: new Date().getTime(),
    }
    localStorage.setItem('loader', JSON.stringify(storageObj))
  },
  compareLocalStorageTimestramp() {
    if (localStorage.getItem('loader') !== null) {
      let object =
          JSON.parse(localStorage.getItem('loader')),
          localDate = object.timestamp,
          now = new Date().getTime()


      return (now - (24 * 60 * 60 * 1000)) >= localDate
    }
    return true
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js